import { defaultErrorProps } from 'components/error-props'

import { withErrorPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page, Props } from '@grandvisionhq/www-next/pages/store-overview'

import { withCms, withLayout } from '../cms'

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout()
)(Page)
